import axios from "axios";

// Base URL del backend (la toma del .env o usa localhost por defecto)
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://backleadscoring.bdtglobal.com",
});


export default api;
